import { Link, ListItem, Text } from '@chakra-ui/react'
import { Link as ReachLink } from 'react-router-dom'
import colors from '../../../config/theme/colors'
import { GroupItemProps } from './types'

export default function GroupItem({ to, label, onClick }: GroupItemProps) {
    return (
        <ListItem color={colors['gray-2']}>
            {to && (
                <Link as={ReachLink} to={to}>
                    {label}
                </Link>
            )}
            {onClick && (
                <Text
                    _hover={{ textDecor: 'underline' }}
                    onClick={onClick}
                    cursor="pointer"
                >
                    {label}
                </Text>
            )}
        </ListItem>
    )
}
